module.exports = __webpack_public_path__ + "static/media/check-icon-green.1bbf1d64.svg";